var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineGridLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h1c.41 0 .75.34.75.75s-.34.75-.75.75H9z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.031 9.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h19.97c.41 0 .75.34.75.75s-.34.75-.75.75H2.031zM2.031 16.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9.97c.41 0 .75.34.75.75s-.34.75-.75.75h-9.97z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76 21.99V2.02c0-.41.34-.75.75-.75s.75.34.75.75v19.97a.749.749 0 1 1-1.5 0zM14.76 11.99V2.02c0-.41.34-.75.75-.75s.75.34.75.75v9.97a.749.749 0 1 1-1.5 0zM19.65 17.2v-.8c0-1.12-.25-1.65-1.65-1.65s-1.65.53-1.65 1.65v.8c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.8c0-2.09 1.06-3.15 3.15-3.15s3.15 1.06 3.15 3.15v.8c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.75c-2 0-2.75-.75-2.75-2.75v-.8c0-2 .75-2.75 2.75-2.75h4c2 0 2.75.75 2.75 2.75v.8c0 2-.75 2.75-2.75 2.75h-4zm-1.25-3.55v.8c0 1.18.07 1.25 1.25 1.25h4c1.18 0 1.25-.07 1.25-1.25v-.8c0-1.19-.06-1.25-1.25-1.25h-4c-1.19 0-1.25.06-1.25 1.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineGridLock);
export default __webpack_public_path__ + "static/media/vuesax-outline-grid-lock.be816d670218a276f2dd58fce974e051.svg";
export { ForwardRef as ReactComponent };